import { Link } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useStateValue } from './StateProvider';
import "./Table.css"
import { db } from './firebase'

function Table({id, title, image, price, date, time}) {
    const [{ basket }, dispatch] = useStateValue();
   
    // console.log('This is the basket >>> ', basket);

    

    const addToBasket = () => {
        // dispatch the item into the data layer
        dispatch({
            type: 'ADD_TO_BASKET',
            item: {
                id: id,
                title: title,
                image: image,
                price: price,
                
            }
        })
    }
   
    return (
        <div className='table'>
            
            <img src={image} alt=""></img>
            {/* <p className='table__title'>{title}</p> */}
            <button className='table__title' onClick={addToBasket}>{title}</button>
            <p className='product__price'>
                <small>₹</small>
                <strong>{price}</strong>
                
            </p>
        </div>
        
       
    )
}

export default Table
